import { styled } from '@mui/material'
import { ActionButton } from '@/components/primitives/buttons/ActionButton'

export const SectionButton = styled(ActionButton, { name: 'SectionButton' })({
  padding: 0,
  margin: 0,
})
